var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 25,
    viewBox: "0 0 17 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 23.375V20.9583C1.25 19.6765 1.75922 18.4471 2.66565 17.5407C3.57208 16.6342 4.80145 16.125 6.08333 16.125H10.9167C12.1985 16.125 13.4279 16.6342 14.3343 17.5407C15.2408 18.4471 15.75 19.6765 15.75 20.9583V23.375M3.66667 6.45833C3.66667 7.74021 4.17589 8.96959 5.08232 9.87602C5.98874 10.7824 7.21812 11.2917 8.5 11.2917C9.78188 11.2917 11.0113 10.7824 11.9177 9.87602C12.8241 8.96959 13.3333 7.74021 13.3333 6.45833C13.3333 5.17645 12.8241 3.94708 11.9177 3.04065C11.0113 2.13422 9.78188 1.625 8.5 1.625C7.21812 1.625 5.98874 2.13422 5.08232 3.04065C4.17589 3.94708 3.66667 5.17645 3.66667 6.45833Z",
    stroke: "#4F295D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b85ac9e223075674887e2e9a0f25e38b.svg";
export { ForwardRef as ReactComponent };